import React from 'react'
import { useSelector } from 'react-redux'

import Text from 'components/common/Text'
import { Color } from 'constants/color'
import { difference } from 'helpers/lodash'
import { _remoteParticipants } from 'store/selectors/Room'
import { isDesktop } from 'utils/device'

import {
    Wrapper,
    LoaderWrapper,
    textStyles,
    UnattemptedStudents,
} from './styles'

import { assetsBase } from '../constants'
import DotPulseLoader from '../DotPulseLoader'
import { renderUsers } from '../helpers'

export const WaitingToResume = ({ isTimerOver, text }) => {
    const content = isDesktop
        ? 'Waiting for teacher to resume'
        : 'Next question'
    return (
        <Wrapper $isWaiting isTimerOver={isTimerOver}>
            <LoaderWrapper>
                <DotPulseLoader />
            </LoaderWrapper>
            <Text css={textStyles}>{text || content}</Text>
        </Wrapper>
    )
}

export const QuestionTracker = ({
    totalQues = 0,
    currentQues = 0,
    isTimerOver,
}) => {
    return (
        <Wrapper isTimerOver={isTimerOver}>
            <Text
                css={textStyles}
                color={!isTimerOver ? Color.black : Color.white}
            >
                {currentQues} of {totalQues}
            </Text>
        </Wrapper>
    )
}

export const UnattemptedStudentsList = ({ choices = [] }) => {
    const remoteParticipantNames = useSelector(state =>
        _remoteParticipants(state, 'name')
    )
    const studentsAttempted = [].concat(
        ...Object.values(choices).map(choice => choice.users)
    )

    const studentsUnattempted = difference(
        remoteParticipantNames,
        studentsAttempted
    )

    if (!studentsUnattempted.length) return null

    return (
        <UnattemptedStudents.Wrapper>
            <UnattemptedStudents.Icon>
                <img src={`${assetsBase}/skipped.svg`} />
            </UnattemptedStudents.Icon>
            <Text level="2" bold={false} color={Color.black}>
                {renderUsers(studentsUnattempted)} did not attempt
            </Text>
        </UnattemptedStudents.Wrapper>
    )
}
